import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Utils

import { validateValueByValidationType } from '@utils/validators/validators';

const Input  = props => {

    const {
        inputData: {
            disabled,
            id,
            isInputRequired,
            helperClasses,
            name,
            placeholder,
            type,
            value,
            validationType,
            autoComplete = 'off',
        },
        inputActions: {
            handleFieldChange,
            handleFieldBlur,
            tracker
        },
        label: {
            text,
            labelClasses,
            ariaLabel,
        },
        labelIcon = {}
    } = props;

    const sendTrackedValues = value => {
        if(typeof tracker === 'function') {
            const valid = validateValueByValidationType(value, validationType);

            tracker({ value, valid });
        }

        return null;
    };

    const handleValueChange = e => {
        const nextValue = e.target.value;

        sendTrackedValues(nextValue);
        handleFieldChange(nextValue);
    };

    const handleValueBlur = e => {
        const originalValue = e.target.value;
        const trimmedValue = e.target.value.trim();

        if(originalValue !== trimmedValue) {
            handleFieldChange(trimmedValue);
            handleFieldBlur?.(trimmedValue);
        }

        handleFieldBlur?.(trimmedValue);
    };

    return (
        <Fragment>
            <div className={`grid-row gi-component gi-${type} ${helperClasses && helperClasses.join(' ')}`}>
                <label
                    data-testid = { `${id}_label` }
                    htmlFor={id}
                    className={`tablet:grid-col-4 m-0 gi-${type}__label ${labelClasses && labelClasses.join(' ')} iconed-${!!labelIcon.icon} required-${isInputRequired}`}
                    aria-label={ariaLabel}
                >
                    { text }
                    { labelIcon.icon ? labelIcon.icon : null }
                </label>
                <input
                    id={id}
                    className={`tablet:grid-col-6 gi-${type}__input`}
                    data-testid = { `${id}_input` }
                    disabled={disabled}
                    name={name}
                    autoComplete={autoComplete}
                    type="text"
                    value={value || ''}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    onChange={handleValueChange}
                    onBlur={handleValueBlur}
                    onFocus={props.inputActions.onFieldFocus}
                />
            </div>
        </Fragment>
    );
};

Input.propTypes = {
    inputData: PropTypes.shape({
        name: PropTypes.string.isRequired,
        classes: PropTypes.arrayOf([PropTypes.string]),
        value: PropTypes.any,
        placeholder: PropTypes.string,
    })
};

export default Input;
